import React, {  useState } from "react";
import {GraphQlSelect} from "./GraphQlSelect";
import { useClientCompanyContactListQuery} from "../../generated/graphql";
import {GraphQlSelectId} from "./GraphQlSelectId";

export const ClientCompanyContactSelect = (props) => {
    const [searchTerm,setSearchTerm] = useState('');
    const valueQuery = useClientCompanyContactListQuery({variables:{ids:props.value}});
    const query = useClientCompanyContactListQuery({variables:{name:searchTerm?'%'+searchTerm+'%':''}});
    return props.valueIsId?
    <GraphQlSelectId {...props} queryResult={query} labelField="name" setSearchTerm={setSearchTerm} valueQuery={valueQuery} loading={valueQuery.loading || query.loading} />
    :<GraphQlSelect {...props} queryResult={query} labelField="name" setSearchTerm={setSearchTerm} valueQuery={valueQuery} loading={valueQuery.loading || query.loading} />;
}